import React, {useState} from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import StudentSubHeaderBar from '../components/StudentSubHeaderBar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="App">
      <Sidebar sidebarOpen={sidebarOpen} />
      <div className={`dashboard-main ${!sidebarOpen ? 'active' : ''}`}>
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <StudentSubHeaderBar />
        <div className="dashboard-main-body">
          <Outlet /> {/* Pages will render here */}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
